module.exports = __webpack_public_path__ + "images/munsterhuis_smalld2e2bbb9e8e84f417056523ed3651dac.png";